<style src="./view.scss" lang="scss"></style>
<template src="./view.html"></template>

<script>
import upload from "@/components/upload.vue";
import { verifyField } from "@/common/utils";
import { Message } from  'element-ui'

export default {
    components: { upload },
    data() {
        return {
            form: {
                frequencyType: "1",
                shiquanCoinLimit: '',
            },
            verifyRules: {
                taskType: [{ required: true, message: "请选择任务条件" }],
                taskIcon: [{ required: true, message: "请上传图片" }],
                shiquanCoin: [
                    { required: true, message: "请输入积分奖励数量" },
                    {
                        validator: (val) => +val >= 0,
                        message: "请输入大于等于0的积分奖励数量",
                    },
                    {
                        validator: (val) => +val <= 1000,
                        message: "请输入小于等于1000的积分奖励数量",
                    },
                ],
                sortWeight: [
                    { required: true, message: "请输入排序权重" },
                    {
                        validator: (val) => +val > 0,
                        message: "请输入排序权重大于0的整数",
                    },
                ],
                status: [{ required: true, message: "请设置状态" }],
            },
            pageType: "",
            options: [
                {value:"1",label:'每日'},
                {value:"2",label:'单次'}
            ],
            tabData: [],
        };
    },
    methods: {
        init() {
            this.pageType = this.$route.query.pageType; 
            if (this.pageType === "view" || this.pageType === "modify") {
                this.getPrizeDetail();
                if(this.$route.query.frequencyType){
                    this.form.frequencyType = this.$route.query.frequencyType;
                }
            }else {
                this.form.status = '1';
            }
            this.getData();
        },
        changeType() {
            this.getData();
            this.form.shiquanCoinLimit = '';
            if(this.form.taskType != undefined){
                this.form.taskType = '';
            }
        },
        async getData() {
            let data = await this.api.pointsystemTaskType({
                access_token: localStorage.getItem("access_token"),
                frequency_type: this.form.frequencyType,
            });
            this.tabData = data.data;
        },
        async getPrizeDetail() {
            let id = this.$route.query.id;
            let data = await this.api.pointsystemDetail({
                id,
                access_token: localStorage.getItem("access_token"),
            });
            this.form = data;
        },
        change() {
            this.$forceUpdate()
        },
        async prizeAdd() {
            if (verifyField(this.verifyRules, this.form)) {
                if(this.form.frequencyType == 1&&!this.form.shiquanCoinLimit){
                    Message({type: 'error', message: '请输入每日完成上限'})
                    return    
                }
                await this.api[
                    this.pageType === "modify" ? "pointsystemEdit" : "pointsystemAdd"
                ](
                    Object.assign(this.form, {
                        access_token: localStorage.getItem("access_token"),
                    })
                );

                if(this.pageType === 'modify') {
                    this.$message({ message: '保存成功', type: 'success' })
                }else {
                    this.$message({ message: '添加成功', type: 'success' })
                }
                this.$router.back()
            }
        },
        httprequest(params) {
            const _file = params.file;
            this.file = params.file
            let _this = this
            let app_secret = '1Q61s1iP8I376GyMTdsjOzd4hcLpZ4SG';
            let open_id = 7;
            let times = (Date.parse(new Date()) / 1000);
            let arr = [
                1003,
                app_secret,
                open_id,
                times
            ];

            // 通过 FormData 对象上传文件
            var formData = new FormData();
            formData.append("file", _file);
            formData.append('app_id', 1003);
            formData.append('sign', this.MD5(encodeURIComponent(arr.sort())))
            formData.append('user', open_id)
            formData.append('relation_type', 'activity')
            formData.append('timestamp', times)
            _this.$parent.setpercentage("start");
            this.axios.post(window.file_upload_baseURL, formData).then(function(response) {
                const fileName = response.data.data.url.lastIndexOf('.');
                const fileNameLen = response.data.data.url.length;
                const fileTypeName = response.data.data.url.substring(fileName + 1, fileNameLen).toUpperCase();
                if(fileTypeName == 'GIF'){
                    _this.form.gifFiles = response.data.data.url
                }else{
                    _this.form.previewFiles = response.data.data.url;
                }
                _this.$parent.setpercentage("end", response.data.data.url);
            }).catch(function(error) {
                console.log(error);
            });
            //console.log(this.form.banner = url)
        },
        setimgurl(url) {
            const fileName = url.lastIndexOf('.');
            const fileNameLen = url.length;
            const fileTypeName = url.substring(fileName + 1, fileNameLen).toUpperCase();
            if(fileTypeName == 'GIF'){
                this.form.gifFiles = url
            }else{
                this.form.previewFiles = url;
            }
        },
    },
    created() {
        this.init();
    },
};
</script>
